import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

const { TextArea } = Input;
const { Option } = Select;


interface TemplateModelProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        template_id?: number;
        template_type?: string;
        template_name?: string;
    } | null;
    isEditMode?: boolean;
}

const TemplateModel: React.FC<TemplateModelProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    // Handle form submit
    const handleAddTemplate = async (values: any) => {
        try {
            const dataVal = {
                template_name: values.template_name,
                template_type: values.template_type,
                ...(initialValues?.template_id && { template_id: initialValues.template_id }),
            };
            const url = isEditMode
                ? 'edit-template'
                : 'add-template';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'Template updated successfully!' : 'Template created successfully!',
            );
            form.resetFields();

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} template`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                template_name: initialValues.template_name,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);




    return (
        <Modal
            title={isEditMode ? 'Edit Template' : 'Add New Template'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnHidden
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddTemplate}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="template_name"
                            className='px-8'
                            label={
                                <span>
                                    Template Name&nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 255 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Template Name' },
                                { max: 255, message: 'Maximum 255 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={255}
                                placeholder="e.g., Template "

                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="template_type"
                            label={
                                <span>
                                    Template Type&nbsp;
                                </span>
                            } >
                            <Select
                                style={{ width: '100%', }}
                                dropdownStyle={{ borderRadius: 10 }}
                            >
                                <Option value="Admit Card">Admit Card</Option>
                                <Option value="Result">Result</Option>
                                <Option value="Fees Receipt">Fees Receipt</Option>
                                <Option value="ID Card">ID Card</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>



                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Template
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default TemplateModel;
